export var PaymentMethods;

(function (PaymentMethods) {
  PaymentMethods["PAY_AT_RESTAURANT"] = "payatrest";
  PaymentMethods["ONLINE"] = "online";
})(PaymentMethods || (PaymentMethods = {}));

export var FallbackReasonCode;

(function (FallbackReasonCode) {
  FallbackReasonCode["CC_TOKENIZATION_FAILURE"] = "CC_TOKENIZATION_FAILURE";
  FallbackReasonCode["ORDER_SESSION_TOKEN_FAILURE"] = "ORDER_SESSION_TOKEN_FAILURE";
  FallbackReasonCode["GOOGLEPAY_INIT_FAILURE"] = "GOOGLEPAY_INIT_FAILURE";
  FallbackReasonCode["APPLEPAY_INIT_FAILURE"] = "APPLEPAY_INIT_FAILURE";
  FallbackReasonCode["PAYPAL_INIT_FAILURE"] = "PAYPAL_INIT_FAILURE";
  FallbackReasonCode["GOOGLEPAY_DP_FAILURE"] = "GOOGLEPAY_DP_FAILURE";
  FallbackReasonCode["APPLEPAY_DP_FAILURE"] = "APPLEPAY_DP_FAILURE";
  FallbackReasonCode["PAYPAL_DP_FAILURE"] = "PAYPAL_DP_FAILURE";
})(FallbackReasonCode || (FallbackReasonCode = {}));

export var OnlinePaymentTypes;

(function (OnlinePaymentTypes) {
  OnlinePaymentTypes["CREDIT_CARD"] = "cc";
  OnlinePaymentTypes["PAYPAL"] = "paypal";
  OnlinePaymentTypes["GOOGLE_PAY"] = "gp";
  OnlinePaymentTypes["APPLE_PAY"] = "ap";
  OnlinePaymentTypes["NONE"] = "none";
})(OnlinePaymentTypes || (OnlinePaymentTypes = {}));

export var PickupMethod;

(function (PickupMethod) {
  PickupMethod["CARSIDE"] = "CARSIDE";
  PickupMethod["IN_RESTAURANT"] = "IN_RESTAURANT";
})(PickupMethod || (PickupMethod = {}));

export var PaymentFlow;

(function (PaymentFlow) {
  PaymentFlow["CHECKOUT"] = "CHECKOUT";
  PaymentFlow["GC_CHECKOUT"] = "GC_CHECKOUT";
  PaymentFlow["MPAY_CLQ"] = "CLQ";
  PaymentFlow["MPAY_TLQ"] = "TLQ";
  PaymentFlow["MPAY_OPCIO"] = "OPCIO";
})(PaymentFlow || (PaymentFlow = {}));

export var MPAnalyticsPaymentMethod;

(function (MPAnalyticsPaymentMethod) {
  MPAnalyticsPaymentMethod["GIFT"] = "giftCard";
  MPAnalyticsPaymentMethod["CREDIT"] = "creditCard";
  MPAnalyticsPaymentMethod["PAYPAL"] = "PayPal";
  MPAnalyticsPaymentMethod["APPLEPAY"] = "ApplePay";
  MPAnalyticsPaymentMethod["GOOGLEPAY"] = "GooglePay";
})(MPAnalyticsPaymentMethod || (MPAnalyticsPaymentMethod = {}));

export var DialogueCodes;

(function (DialogueCodes) {
  DialogueCodes["CHARGE_BACK_GUEST"] = "901";
  DialogueCodes["PAYMENT_CODE_BLACKLISTED_IN_APP"] = "810";
  DialogueCodes["PAYMENT_CODE_REGEX_VALIDATION"] = "201";
  DialogueCodes["PAYMENT_CODE_INVALID_API"] = "202";
  DialogueCodes["CONNECTIVITY_ERROR"] = "501";
  DialogueCodes["CHECK_CLOSED"] = "111";
  DialogueCodes["CHECK_SATISFIED"] = "601";
  DialogueCodes["CHECK_NOT_FOUND"] = "011";
  DialogueCodes["FRAUD_SUSPICION_LOCK"] = "701";
  DialogueCodes["MAX_THRESHOLD_ERROR"] = "999";
  DialogueCodes["PAYMENT_FAILURE_THRESHOLD_ERROR"] = "310";
  DialogueCodes["PAYMENT_LOAD_CHECK_ERROR"] = "701";
  DialogueCodes["PAYMENT_LOCK_ORDER_ERROR"] = "001";
  DialogueCodes["PAYMENT_INVALID_CODE_ERROR"] = "191";
  DialogueCodes["PAYMENT_CONNECTIVITY_ERROR"] = "501";
  DialogueCodes["PAYMENT_CLOSED_CHECK"] = "111";
  DialogueCodes["PAYMENT_DFP_REJECT"] = "444";
  DialogueCodes["CHECK_ALREADY_PAID"] = "666";
  DialogueCodes["ERROR_CASE_MISSING"] = "667";
  DialogueCodes["TLQ_NOT_ENABLED_ERROR"] = "668";
  DialogueCodes["ERROR_AVAILABLE_ON_APP"] = "557";
  DialogueCodes["ERROR_AVAILABLE_ON_WEB"] = "558";
  DialogueCodes["ERROR_MOBILE_PAY_NOT_AVAILABLE"] = "559";
  DialogueCodes["MULTIPLE_CHECKS_FOUND"] = "012";
  DialogueCodes["ERROR_APPLY_COUPON_FAILURE"] = "340";
  DialogueCodes["ERROR_REMOVE_COUPON"] = "341";
  DialogueCodes["ERROR_COUPON_NOT_APPLICABLE_OR_INVALID"] = "342";
  DialogueCodes["ERROR_CHECK_VERSION_MISMATCH"] = "013";
  DialogueCodes["PAYPAL_PAYMENT_FAILED"] = "412";
  DialogueCodes["PAYPAL_AUTHORIZATION_FAILED"] = "413";
  DialogueCodes["PAYPAL_PAYMENT_CANCELLED"] = "414";
  DialogueCodes["ERROR_CC_TOKENIZATION_BUSINESS_FAULT"] = "451";
  DialogueCodes["ERROR_CC_TOKENIZATION_TECHNICAL_FAILURE"] = "452";
  DialogueCodes["ERROR_ORDER_SESSION_TOKEN_FAILURE"] = "453";
  DialogueCodes["ERROR_PAY_AT_RESTAURANT_NOT_SUPPORTED"] = "454";
  DialogueCodes["ERROR_INVALID_ORDER_TOTAL"] = "455";
  DialogueCodes["ERROR_CHECK_NOT_LOADED"] = "456";
  DialogueCodes["ERROR_ERROR_CHECK_OVER_PAID"] = "471";
  DialogueCodes["ERROR_MERCHANT_ID_NOT_FOUND"] = "472";
  DialogueCodes["ERROR_GENERIC_PAYMENT_FAILURE"] = "473";
  DialogueCodes["ERROR_PAYMENT_EXCEPTIONS"] = "474";
  DialogueCodes["ERROR_FRAUD_PAYMENT_TOKEN"] = "475";
  DialogueCodes["ERROR_DFP_CHECK_LOCKED"] = "476";
  DialogueCodes["ERROR_BAMS_ERROR_RESPONSE"] = "477";
  DialogueCodes["ERROR_SESSION_EXPIRY"] = "321";
  DialogueCodes["ERROR_CUSTOM_GRATUITY_THRESHOLD_EXCEEDS"] = "979";
  DialogueCodes["ERROR_SUBMIT_ORDER_FAIL"] = "802";
  DialogueCodes["ERROR_FAULTS_NOT_HANDLED"] = "669";
  DialogueCodes["GOOGLE_PAY_PAYMENT_FAILED"] = "432";
  DialogueCodes["GOOGLE_PAY_AUTHORIZATION_FAILED"] = "433";
  DialogueCodes["GOOGLE_PAY_PAYMENT_CANCELLED"] = "434";
  DialogueCodes["APPLE_PAY_PAYMENT_FAILED"] = "422";
  DialogueCodes["APPLE_PAY_AUTHORIZATION_FAILED"] = "423";
  DialogueCodes["APPLE_PAY_PAYMENT_CANCELLED"] = "424";
  DialogueCodes["ERROR_SHORT_TOKEN_SUMMARY"] = "645";
  DialogueCodes["ERROR_SHORT_TOKEN_MISSING"] = "646";
  DialogueCodes["ERROR_SEND_MAIL_RECEIPT_FAILED"] = "723";
  DialogueCodes["SEND_MAIL_RECEIPT_SUCCESS"] = "722";
  DialogueCodes["ERROR_DRI_570"] = "478";
  DialogueCodes["LARGE_PARTY_CHECKS_FOUND"] = "014";
  DialogueCodes["ERROR_CHECK_TOTAL_ZERO"] = "015";
})(DialogueCodes || (DialogueCodes = {}));

export var LocationServiceStatus;

(function (LocationServiceStatus) {
  LocationServiceStatus["NEVER"] = "Never";
  LocationServiceStatus["ASK_NEXT_TIME"] = "Ask next time";
  LocationServiceStatus["WHILE_USING_THE_APP"] = "While using the app";
  LocationServiceStatus["ALWAYS"] = "Always";
})(LocationServiceStatus || (LocationServiceStatus = {}));

export var RSATokenTransactionType;

(function (RSATokenTransactionType) {
  RSATokenTransactionType["PROFILE"] = "ProfileRSAToken";
  RSATokenTransactionType["TOGO"] = "ToGoRSAToken";
  RSATokenTransactionType["MOBILE_PAY"] = "MobilePayRSAToken";
  RSATokenTransactionType["GIFTCARD"] = "GiftCardRSAToken";
})(RSATokenTransactionType || (RSATokenTransactionType = {}));

export var CheckoutDialogueCodes;

(function (CheckoutDialogueCodes) {
  CheckoutDialogueCodes["ERROR_CASE_MISSING"] = "001";
})(CheckoutDialogueCodes || (CheckoutDialogueCodes = {}));